import { Component, ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { AdminApi } from '../admin-api';
import CropPhoto from './CropPhoto';
import Header from './Header';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

export type CoverPhoto = {
  id: number;
  photoUrl: string;
  index: number;
};

export default function CoverPhotos(props: any): ReactNode {
  return <CoverPhotosComp {...props} navigate={useNavigate()} />;
}

class CoverPhotosComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: false,
      isSidebarExpanded: false,
      photos: [],
    };
  }

  state: Readonly<{
    isLoading: boolean;
    isSidebarExpanded: boolean;
    photos: CoverPhoto[];
  }>;

  _maxPhotos = 10;

  async componentDidMount(): Promise<void> {
    this.setState({ isLoading: true });

    const _data = await AdminApi.get('/cover-photos');
    this.setState({ photos: _data });

    this.setState({ isLoading: false });
  }

  async removePhoto(i: number) {
    await AdminApi.delete(`/cover-photos/${i}`);
    this.setState({
      photos: this.state.photos.filter((p) => p.index !== i),
    });
  }

  async uploadPhoto(i: number, key: string): Promise<string> {
    const _newUrl = await AdminApi.put(`/cover-photos/${i}`, {
      key: key,
    });

    this.setState({
      photos: [...this.state.photos, { photoUrl: _newUrl, index: i, id: i }],
    });

    return _newUrl;
  }

  changeSidebar(expanded: boolean) {
    this.setState({
      isSidebarExpanded: expanded,
    });
  }

  sizeClasses() {
    return this.state.isSidebarExpanded
      ? `col-md-9 col-lg-10`
      : `large-calendar`;
  }

  renderPhotos() {
    let _result = [];
    for (let i = 0; i < this._maxPhotos; i++) {
      const _photoThisIndex = this.state.photos.find((p) => p.index === i);

      _result.push(
        <div className="col-md-6 col-lg-6 mt-3" key={i}>
          <CropPhoto
            className="img-thumbnail cover-photo"
            cardTitle={`${i + 1}ª foto`}
            cardHelpText=""
            onRemove={() => this.removePhoto(i)}
            onUpload={(key: string) => this.uploadPhoto(i, key)}
            uploaded={_photoThisIndex?.photoUrl}
            currentUser={this.props.currentUser}
            cropProps={{
              aspect: 0.7,
              maxWidth: 1000,
              maxHeight: 1000,
              minWidth: 440,
              minHeight: 480,
              style: { maxHeight: '700px' },
            }}
          />
        </div>,
      );
    }

    return _result;
  }

  render() {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
              initialExpanded={this.state.isSidebarExpanded}
              onChangeSidebar={(expanded: boolean) =>
                this.changeSidebar(expanded)
              }
            ></Sidebar>
            <main className={`ms-sm-auto px-md-4 ${this.sizeClasses()}`}>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Adicione as fotos de capa do site</h1>
              </div>
              <div className="row">{this.renderPhotos()}</div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
